









































































































import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class BreathAnalysis extends Vue {
  // Props
  @Prop(Object) public rec!: object;
  @Prop(Boolean) public isReadOnly!: boolean;

  public parseNumber(n) {
    // Replace all commas to dots and convert string to number
    return n ? Number(n.replace(/,/g, '.')) : n;
  }

  public calculateValue(breath, i) {
    // 'A' als gemeten waarde (F7) kleiner is dan de standaard waarde (B7) + maximum afwijking (F4) - meetonzekerheid (H7)
    // 'W' als gemeten waarde (F7) groter is dan de standaard waarde (B7) - maximum afwijking (F4) + meetonzekerheid (H7)
    // Ook A als de gemeten waarde groter is dan de standaard waarde – maximum warde + meetonzekerheid
    // =IF((F45<B45+H42-H45)*OR(F45>B45-H42+H45);"A";"W")
    // Met volgende velden:
    // -          F45: Gemeten waarde
    // -          B45: Standaard waarde
    // -          H42: maximum toegestane afwijking
    // -          H45: meetonzekerheid
    const standard: number = this.parseNumber(breath['standard_l' + i]);
    const measure: number = this.parseNumber(breath['measure_l' + i]);
    const maxAllowedDev: number = this.parseNumber(breath.max_allowed_dev);
    const uncertain: number = this.parseNumber(breath['uncertain_l' + i]);
    if (standard && measure && maxAllowedDev && uncertain) {
      const f1: number = standard + maxAllowedDev - uncertain;
      const f2: number = standard - maxAllowedDev + uncertain;
      if (measure <= f1 && measure >= f2) {
        return 'A';
      } else {
        if (measure > f1) {
          return 'W';
        }
        if (measure < f2) {
          return 'W';
        }
      }
    }
  }

  public calculateTooltip(breath, i) {
    const standard: number = this.parseNumber(breath['standard_l' + i]);
    const measure: number = this.parseNumber(breath['measure_l' + i]);
    const maxAllowedDev: number = this.parseNumber(breath.max_allowed_dev);
    const uncertain: number = this.parseNumber(breath['uncertain_l' + i]);
    const f1: number = standard + maxAllowedDev - uncertain;
    const f2: number = standard - maxAllowedDev + uncertain;
    if (standard && measure && maxAllowedDev && uncertain) {
      if (measure < f1 && measure > f2) {
        return (
          String(f1.toFixed(3)) +
          '>' +
          String(measure) +
          '>' +
          String(f2.toFixed(3))
        );
      } else {
        if (measure >= f1) {
          return String(measure) + '>=' + String(f2.toFixed(3));
        }
        if (measure <= f2) {
          return String(measure) + '<=' + String(f2.toFixed(3));
        }
      }
    }
  }

  public validateTemp(breath) {
    const temps: number[] = [];
    // Create array of temps
    for (let i = 1; i < 4; i++) {
      if (this.parseNumber(breath['temp_l' + i])) {
        // Parse to number and add to temps array
        temps.push(this.parseNumber(breath['temp_l' + i]));
      }
      if (this.parseNumber(breath['temp_l' + i + 'b'])) {
        // Parse to number and add to temps array
        temps.push(this.parseNumber(breath['temp_l' + i + 'b']));
      }
    }
    if (temps.length > 0) {
      const min = Math.min.apply(null, temps);
      const max = Math.max.apply(null, temps);
      if (max - min <= 4) {
        return 'OK';
      } else {
        return 'NOK';
      }
    } else {
      // No temps
      return '';
    }
  }
}
